import { Fragment } from 'react'

import { Banner, FormattedMessage } from '@b-stock/fe-core/bstock-react'

const ns = 'Offerings.Details.offeringStatusBanner.canceled'

export const CanceledOfferingBanner = () => {
  return (
    <Banner title={<FormattedMessage id={`${ns}.title`} />} type="error">
      <Fragment />
    </Banner>
  )
}
